/**
 * @module app.core
 */

import { autoinject, bindingMode } from 'aurelia-framework';
import { ComponentBase, IForm } from 'app/shared/lib/essette-site';
import { CustomFieldService } from 'app/core/services/custom-field-service';
import { Toaster } from 'app/shared/lib/toaster';
import { bindable } from 'aurelia-typed-observable-plugin';
import { forceNull } from 'app/shared/lib/utilities';
import { apiCall } from 'app/shared/lib/essette-api';
import { I18N } from 'aurelia-i18n';
import * as Core from 'app/core/models/essette-api';

@autoinject
export class SaveUserDefinedField extends ComponentBase implements IForm {

    ////****************** Fields and Properties ************************************////
    @bindable({ defaultBindingMode: bindingMode.toView })
    protected customFieldDefinition: Core.CustomFieldDefinition = {};

    ////****************** Element References ***************************************////

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly toaster: Toaster,
        private readonly service: CustomFieldService,
        private readonly i18n: I18N,
        ...rest: any[]) {
        super(...rest);
    }

    protected bind(): void {
        // verify that component is properly configured
    }

    ////****************** Events ***************************************************////

    ////****************** Functions ************************************************////
    public hasChanges(): boolean {
        throw new Error('Method not implemented.');
    }

    public async submit(): Promise<boolean> {
        return await this.saveCustomFieldDefinition();
    }

    protected constructSaveObject(): Core.CustomFieldDefinition {
        const saveCustomFieldDefinition: Core.CustomFieldDefinition = {
            description: this.customFieldDefinition.label?.general?.one,
            label: {
                general: {
                    other: this.customFieldDefinition.label?.general?.other
                },
                code: {
                    other: forceNull(this.customFieldDefinition.label?.code?.other)
                }
            }
        }
        if(this.customFieldDefinition.id) {
            saveCustomFieldDefinition.id = this.customFieldDefinition.id;
        }
        else {
            saveCustomFieldDefinition.field = {
                id: this.customFieldDefinition.field?.id
            };
        }

        return saveCustomFieldDefinition;
    }

    ////****************** Service Calls ********************************************////
    @apiCall
    private async saveCustomFieldDefinition(): Promise<boolean> {
        let isSuccessful = false;
        let duplicateCodeError = false;
        try {
            this.state.beginSave();
            const response = await this.service.saveCustomFieldDefinition(this.constructSaveObject());
            isSuccessful = response.isSuccessful;
        } catch(error) {
            if(error.status?.errors) duplicateCodeError = error.status.errors.some((err: any) => err.code === 'property.constraintViolated' && err.property === 'code');
            throw error;
        } finally {
            if(duplicateCodeError) {
                this.toaster.error().message(this.i18n.tr('ui:messages.duplicate.save_error', { what: this.i18n.tr('core:note.category.code.$'), item: this.i18n.tr('core:note.category.$long') })).show();
            } else {
                this.toaster.standard.saved('core:customField.$long', isSuccessful);
            }
            this.state.endSave();
            return isSuccessful;
        }
    }
}
